
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bantuan/proses-proyek",
      function () {
        return require("private-next-pages/bantuan/proses-proyek.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bantuan/proses-proyek"])
      });
    }
  